import React, { useState } from "react";

import { Ds } from "@accurx/design";
import { AppointmentTypeValue } from "domains/self-book/utils/types";

import { SubTitlePositioning } from "../SelfbookConfigurationForm.styles";

type AppointmentTypeOption = {
    id: string;
    label: string;
    value: AppointmentTypeValue;
};

const radioInputs: AppointmentTypeOption[] = [
    { id: "faceToFace", label: "Face-to-face", value: "FaceToFace" },
    { id: "telephone", label: "Telephone", value: "Telephone" },
];

type AppointmentTypeProps = {
    selectedAppointmentType: AppointmentTypeValue;
    onChange: (value: AppointmentTypeValue) => void;
    errors?: string[];
};

export const AppointmentType = ({
    selectedAppointmentType,
    onChange,
    errors,
}: AppointmentTypeProps) => {
    const [selectedValue, setSelectedValue] = useState<string>(
        selectedAppointmentType,
    );

    const onAppointmentTypeChange = (value: string) => {
        setSelectedValue(value);
        onChange(value as AppointmentTypeValue);
    };

    const isFaceToFace = selectedValue === "FaceToFace";

    return (
        <Ds.Box py="1.5rem">
            <Ds.Fieldset name="appointment-type">
                <Ds.Legend>Appointment type</Ds.Legend>
                <Ds.RadioGroup
                    name="appointment-type"
                    defaultValue={selectedValue}
                    value={selectedValue}
                    onValueChange={(value) => {
                        onAppointmentTypeChange(value);
                    }}
                    appearance="solid"
                >
                    <Ds.Grid
                        columns={{ xs: "1fr 1fr", sm: "1fr", xl: "1fr 1fr" }}
                        gap="1"
                    >
                        {radioInputs.map((item) => (
                            <Ds.RadioGroup.Item
                                value={item.value}
                                key={item.value}
                            >
                                <Ds.RadioGroup.Indicator />
                                <Ds.RadioGroup.Label>
                                    {item.label}
                                </Ds.RadioGroup.Label>
                            </Ds.RadioGroup.Item>
                        ))}
                    </Ds.Grid>
                </Ds.RadioGroup>

                <Ds.Flex alignItems="flex-start">
                    <Ds.Icon
                        name={isFaceToFace ? "Team" : "Phone"}
                        size="small"
                    />
                    <SubTitlePositioning>
                        <Ds.Text>
                            {isFaceToFace
                                ? "Patient can select an exact appointment time."
                                : "Patient can select an AM or PM window for a phone call."}
                        </Ds.Text>
                    </SubTitlePositioning>
                </Ds.Flex>
                {errors &&
                    errors.map((item) => (
                        <Ds.Form.Error key={item}>{item}</Ds.Form.Error>
                    ))}
            </Ds.Fieldset>
        </Ds.Box>
    );
};
